const dict = {
  chooseLang: "Sprache auswählen",

  // Lizenz
  instructions: "Anweisungen",
  step1: "Schritt 1: QR-Code scannen",
  locateqr: "Finde den QR-Code auf der rechten Seite.",
  useSmartphone:
    "Verwende die Kamera deines Smartphones oder eine QR-Code-Scanner-App, um ihn zu scannen. Dies führt dich zum nächsten Schritt.",
  step2: "Schritt 2: Playlist-Informationen eingeben",
  afterScan:
    "Nach dem Scannen des QR-Codes wirst du aufgefordert, deine Playlist-Informationen einzugeben.",
  makeSure: "Stelle sicher, dass alle erforderlichen Felder ausgefüllt sind.",
  step3: "Schritt 3: Zurück zur App",
  onceYou:
    "Sobald du deine Playlist-Details eingegeben hast, kannst du zur App zurückkehren und deine Erfahrung fortsetzen.",
  refresh: "AKTUALISIEREN",
  playlist: "Playlist",
  bigPlaylist: "PLAYLISTS",
  noLicence: "Du hast keine Lizenz.",
  scanLicence: "Scanne, um eine Lizenz zu kaufen.",
  noPlaylist: "Du hast keine Playlist",
  privacyBig: "PRIVATSPHÄRE-MODUS",
  scanToAddBig: "SCANNEN, UM PLAYLIST HINZUZUFÜGEN",
  scanToBuyBig: "SCANNEN, UM LIZENZ ZU KAUFEN",
  orVisit: "oder besuche",
  andenterdeviceID: "und gib diese Geräte-ID ein:",
  removePlaylist: "Playlist entfernen",
  wantToRemove: "Möchtest du sie entfernen?",
  cancelBig: "ABBRECHEN",

  // Startseite
  bigLiveTv: "LIVE-TV",
  bigMovies: "FILME",
  bigSeries: "SERIEN",

  // Kanalmenü
  noChannels: "Diese Playlist enthält keine Kanaldaten",
  searchChannels: "Kanal suchen",
  tapToPlay: "Tippe, um den Videostream abzuspielen.",
  categoryEmpty: "Diese Kategorie ist leer",

  // Filme
  noMovies: "Diese Playlist enthält keine Filmdaten",
  searchMovies: "Filme suchen",

  // Serien
  noSeries: "Diese Playlist enthält keine Serien-Daten",
  searchSeries: "Serien suchen",

  // Entität
  play: "ABSPIELEN",
  recommendations: "Empfehlungen",

  // Benutzerinformationen
  userInfo: "Benutzerinformationen",
  aboutApp: "Über die App",

  // Benutzerkonto
  account: "Konto",
  subscriptions: "Abonnements",
  privacyPilicy: "Datenschutz & Richtlinien",
  languge: "Sprache",
  english: "Englisch",
  italian: "Italienisch",
  german: "Deutsch",
  spanish: "Spanisch",
  french: "Französisch",
  greek: "Griechisch",

  // Letzte Details
  playInfo: "Playlist-Informationen",
  playName: "Playlist-Name:",
  host: "Host:",
  username: "Benutzername:",
  password: "Passwort:",
  packName: "Paketname:",
  expireDate: "Ablaufdatum:",

  // Datenschutzrichtlinie
  one: "1. Haftungsausschluss für Inhalte: Applay ist eine Plattform, die dein digitales Erlebnis verbessern soll. Es ist jedoch wichtig zu beachten, dass Applay keine Video-Inhalte hostet, bereitstellt oder vertreibt. Unser Dienst ist darauf ausgelegt, deine digitale Reise zu unterstützen, aber wir sind nicht verantwortlich für die Verfügbarkeit, Qualität oder den Inhalt von Videomaterial, da dies außerhalb unseres Dienstes liegt.",
  two: "2. Keine Haftung für Inhalte Dritter: Applay LLC haftet nicht für Inhalte Dritter, auf die du über unsere Anwendung zugreifst. Deine Interaktion mit externen Inhalten, einschließlich deren Rechtmäßigkeit, Zuverlässigkeit oder Angemessenheit, erfolgt ausschließlich auf eigenes Risiko.",
  three:
    "3. Zuständigkeit und Einhaltung: Applay LLC unterliegt der Gerichtsbarkeit der Vereinigten Staaten. Benutzer sind dafür verantwortlich, sicherzustellen, dass die Nutzung der Anwendung mit allen lokalen, staatlichen und bundesstaatlichen Gesetzen übereinstimmt.",
  four: "4. Preispolitik: Die Preise für die Dienste von Applay können jederzeit ohne vorherige Ankündigung geändert werden. Durch die Annahme dieser Vereinbarung erkennst du an und stimmst zu, dass sich die Preise ändern können und dass solche Änderungen deinen aktuellen Dienst nicht betreffen, bis dein Abonnement erneuert wird.",
  five: `5. Keine Garantie: Die Applay-Anwendung und ihre Dienste werden "wie besehen" bereitgestellt, ohne ausdrückliche oder stillschweigende Garantien, einschließlich, aber nicht beschränkt auf stillschweigende Garantien der Marktgängigkeit, Eignung für einen bestimmten Zweck und Nichtverletzung.`,
  six: "6. Akzeptanz der Bedingungen: Durch Klicken auf Zustimmen erklärst du dich mit den Bedingungen dieses Haftungsausschlusses einverstanden und erkennst an, dass Verstöße zur Beendigung deines Zugriffs auf die Applay-Dienste führen können.",
  orbixUserAgreement: "Applay BENUTZERVEREINBARUNG UND HAFTUNGSAUSSCHLUSS",
  beforeyouProcc:
    "Bevor du fortfährst, lies bitte die folgenden Bedingungen und akzeptiere sie:",

  // Evomedia Datenschutzrichtlinie
  evomediaTitle: "Evo TV Datenschutzrichtlinie",
  evomediaSubtitle:
    "Bitte lesen Sie die folgenden Informationen darüber, wie Ihre Daten verarbeitet werden:",
  evomediaSection1Title: "1. Technische Datenverarbeitung und -erhebung",
  evomediaSection1Body1:
    "Die evo tv-Anwendung ist ausschließlich als technisches Hilfsmittel für berechtigte Evomedia-Kunden konzipiert. Die Anwendung verfügt über keine manuellen Registrierungsformulare, keine Erstellung von Konten in der App und sammelt keine direkten persönlichen Daten (wie Name, Telefonnummer oder E-Mail-Adresse).",
  evomediaSection1Body2:
    "Um jedoch das Streaming von Medien zu ermöglichen und die Sicherheit des Dienstes zu gewährleisten, verarbeitet das System die folgende Datenkategorie:",
  evomediaSection1Body3:
    "Geräteidentifikatoren: Die MAC-Adresse des Geräts oder eine interne Client-ID wird sicher (über SSL/HTTPS) an unsere Server übertragen, ausschließlich zum Zweck der Validierung, Authentifizierung und Autorisierung des Zugriffs auf die Multimedia-Streaming-Feeds, die mit Ihrem Vertragsplan verknüpft sind.",
  evomediaSection1Body4:
    "Rechtsgrundlage und Zweck: Die Verarbeitung dieser Kennungen ist unbedingt erforderlich für die Erfüllung eines Vertrags (Erbringung des angeforderten Streaming-Dienstes) sowie für die Sicherheit und Betrugsprävention (um sicherzustellen, dass nur autorisierte Geräte auf die geschützten Feeds zugreifen). Diese technischen Daten werden niemals zu Marketingzwecken verwendet, niemals an Dritte weitergegeben und nicht zur Verfolgung Ihres allgemeinen Surfverlaufs genutzt.",
  evomediaSection2Title: "2. Rechte der Nutzer (DSGVO)",
  evomediaSection2Body1:
    "Gemäß der Datenschutz-Grundverordnung (DSGVO) haben Sie, da technische Kennungen mit Ihrem zugrunde liegenden Kundenkonto verknüpft sind, das Recht, auf die mit Ihrem Gerät verbundenen Daten zuzugreifen, sie zu berichtigen, einzuschränken oder deren Löschung zu verlangen. Um diese Rechte auszuüben, kontaktieren Sie uns bitte unter suporte@evomedia.pt.",
  evomediaSection3Title: "3. Datenschutz von Kindern",
  evomediaSection3Body1:
    "Wir vermarkten unsere Dienste nicht direkt an Kinder und erfassen wissentlich keine Daten von Minderjährigen unter 13 Jahren. Der App-Zugang wird vom Kontoinhaber (dem erwachsenen Kunden) verwaltet und autorisiert.",
  evomediaSection4Title: "4. Änderungen dieser Richtlinie",
  evomediaSection4Body1:
    "Wir können unsere Datenschutzrichtlinie von Zeit zu Zeit aktualisieren, um technische Verbesserungen oder regulatorische Änderungen widerzuspiegeln. Aktualisierungen werden sofort wirksam, sobald sie auf dieser Seite veröffentlicht werden.",
  evomediaSection5Title: "5. Kontakt",
  evomediaSection5Body1:
    "Wenn Sie Fragen zu Ihrem Datenschutz oder zur technischen Verwaltung der Anwendung haben, kontaktieren Sie uns bitte über:",
  evomediaSection5Body2: "Offizielle Support-E-Mail: suporte@evomedia.pt",
  evomediaSection5Body3: "E-Mail des Entwicklerkontos: evomediamobile@gmail.com",

  //additional
  exitApp: "Applay beenden",
  wantToExit: "Möchten Sie Applay wirklich beenden?",
  Resume: "Fortsetzen",

  whatsnewinv: "Was ist neu in v",
  whatsnew: "Was ist neu",
  instanthomescreen: "Verbesserte Kanalmenü-Navigation",
  instanthomescreendesc:
    "Verbesserter Navigationsfluss und Benutzererfahrung bei der Kanalauswahl.",
  turbomoviesearch: "Umfassende Einstellungsinformationen",
  turbomoviesearchdesc:
    "Detailliertere Einstellungen und Konfigurationsoptionen an einem Ort gesammelt.",
  lighterondataandbattery: "Intelligente Fortsetzungsfunktion",
  lighterondataandbatterydesc:
    "Speichert und stellt automatisch Ihre Wiedergabeposition nahtlos wieder her.",
  underthehoodfixes: "Interne Verbesserungen",
  underthehoodfixesdesc:
    "Verbesserte Player-Stabilität und Zuverlässigkeit der Suchvorgänge.",
};

export default dict;
